export default __webpack_public_path__ + "static/media/LAND.f92a4104.svg";